/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2020 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */
'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})
exports.GenericCom = void 0

const _app = require('./app.js')

const _preferences = require('./preferences.js')

const _download_manager = require('./download_manager.js')

const _genericl10n = require('./genericl10n.js')

const GenericCom = {}
exports.GenericCom = GenericCom

class GenericPreferences extends _preferences.BasePreferences {
  async _writeToStorage (prefObj) {
    localStorage.setItem('pdfjs.preferences', JSON.stringify(prefObj))
  }

  async _readFromStorage (prefObj) {
    return JSON.parse(localStorage.getItem('pdfjs.preferences'))
  }
}

class GenericExternalServices extends _app.DefaultExternalServices {
  static createDownloadManager (options) {
    return new _download_manager.DownloadManager(options)
  }

  static createPreferences () {
    return new GenericPreferences()
  }

  static createL10n ({
    locale = 'en-US'
  }) {
    return new _genericl10n.GenericL10n(locale)
  }
}

_app.PDFViewerApplication.externalServices = GenericExternalServices
